/* eslint-disable */
export default {
  hide: 'Ocultar',
  end: 'Finalizar',
  keypad: 'Teclado',
} as const;

// @key: @#@"hide"@#@ @source: @#@"Hide"@#@
// @key: @#@"end"@#@ @source: @#@"End"@#@
// @key: @#@"keypad"@#@ @source: @#@"Keypad"@#@
